<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-preview"
      scrollable
      centered
      title="NxGED - Visualizar Arquivo"
      size="xl"
    >
      <div class="row">
        <div class="col-12">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" :src="previewUrl" allowfullscreen></iframe>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-default btn-sm"  v-b-tooltip.hover :title="'Fechar'" @click.prevent="hideModal"><i class="fas fa-times-circle"></i> Fechar</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import GedRepository from '@/shared/http/repositories/ged/ged.js'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'ModalGedPreview',
  mixins: [ActionsForm],
  data () {
    return {
      file: null
    }
  },
  computed: {
    previewUrl () {
      return this.file
    }
  },
  methods: {
    showModal (obj) {
      this.$refs['modal-preview'].show()
      this.$nextTick(() => {
        this.onView(obj)
      })
    },
    hideModal () {
      this.$refs['modal-preview'].hide()
    },
    onView (obj) {
      loading.push()
      GedRepository.Download(obj.id)
        .then((response) => {
          loading.pop()
          const url = window.URL.createObjectURL(new Blob([response.data]))
          this.file = url
          // window.open(url, '_blank')
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/components/modalpreview.vue